import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'

import { useAppSelector } from '../../../redux/hooks'
import {
  PropertyDetailPriceUnitForm,
  PropertyDetailPriceUnitFormValues,
} from '../PropertyDetailPriceUnitForm/PropertyDetailPriceUnitForm'
import { PropertyDetailPriceUnitRentTable } from '../PropertyDetailPriceUnitRentTable/PropertyDetailPriceUnitRentTable'
import { PropertyDetailPriceUnitSaleTable } from '../PropertyDetailPriceUnitSaleTable/PropertyDetailPriceUnitSaleTable'

export const PropertyDetailPriceUnit: FunctionComponent = () => {
  const attributes = useAppSelector(
    state => state.property.price.data?.attributes
  )

  const initialValues = useMemo<PropertyDetailPriceUnitFormValues>(
    () => ({
      unitAreaM2: Math.round(attributes?.unitAreaM2 || 0),
      hasElevator: !!attributes?.hasElevator,
      isNewBuild: !!attributes?.isNewBuild,
      isNonPanelOrBrick: !!attributes?.isNonPanelOrBrick,
      hasTerrace: false,
      hasBalcony: false,
      hasGarage: false,
      loading: !attributes,
    }),
    [attributes]
  )

  const [formValues, setFormValues] =
    useState<PropertyDetailPriceUnitFormValues>(initialValues)

  useEffect(() => {
    setFormValues(initialValues)
  }, [initialValues])

  const onFormValuesChange = useCallback(
    (_: unknown, allValues: PropertyDetailPriceUnitFormValues) =>
      setFormValues(allValues),
    []
  )

  return (
    <div className="flex flex-col space-y-14">
      <PropertyDetailPriceUnitForm
        key={JSON.stringify(initialValues)}
        initialValues={initialValues}
        setFormValues={onFormValuesChange}
      />

      <PropertyDetailPriceUnitRentTable formValues={formValues} />

      <PropertyDetailPriceUnitSaleTable area={formValues.unitAreaM2} />
    </div>
  )
}
